import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'teams';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const TEAMLIST_GET = createApiNamespacedConstants('teamlist_get');
export const AUTOCOMPLETE_TEAMS_GET = createApiNamespacedConstants('autocomplete_teamlist_get');
export const AUTOCOMPLETE_TEAMS_GET_OWN = `${NAMESPACE}/autocomplete_teamlist_get_own`;
export const TEAM_CREATE = createApiNamespacedConstants('team_create');
export const TEAM_REMOVE = createApiNamespacedConstants('team_remove');
export const TEAM_PATCH = createApiNamespacedConstants('team_patch');
export const ASSIGN_TEAM_TO_GROUP = createApiNamespacedConstants('assign_team_to_group');
export const GET_ORGANIZATION_TEAMS_USAGE_CSV = createApiNamespacedConstants('get_organization_teams_usage_csv');
